import { FaWhmcs,FaAngleDoubleUp, FaGg, FaSuperpowers,FaThinkPeaks, FaAssistiveListeningSystems, FaClone, FaCompactDisc } from 'react-icons/fa'; 

export default [
	{
		title: 'Hard Mould',
		description:
			'These are made with photoplastic material that cures with exposure to ultraviolet light. It is easy to keep clean and can be adjusted',
		button: 'Read More',
	 
		user: 'Daniel',
		userProfile: FaWhmcs,
	},
	{
		title: 'Swimming Plug',
		description:
			'Custom moulded earplugs are used by swimmers, surfers, kayakers etc. to reduce the risk of water-borne infection which may lead to hearing damage.',
		button: 'Discover',
		 
		user: 'Samantha',
		userProfile: FaAngleDoubleUp,
	},
	{
		title: 'In-the-Ear (ITE) - Shell',
		description:
			'For mild to severe hearing loss, Larger one-piece hearing aid, All components contained in a custom-fit, hard-moulded plastic shell, Fills the entire bowl of the ear, Visible in the ear',
		button: 'Buy now',
		 
		user: 'Michael',
		userProfile: FaGg,
	},
	{
		title: 'Soft Mould',
		description:
			'These are made with silicone and are shaped according to the form of your ear. They are great for active children, and are mostly used for severe degrees of hearing loss.',
		button: 'Buy now',
 
		user: 'Michael',
		userProfile: FaSuperpowers,
	},
	{
		title: 'Completely-in-the-Canal (CIC) - Shell',
		description:
			'For mild to moderately-severe hearing loss, Very small one-piece hearing aid, All components contained in a custom-fit, hard-molded plastic shell, Fits inside the ear canal, Barely visible or not visible at all in the ear canal',
		button: 'Buy now',
	 
		user: 'Michael',
		userProfile: FaThinkPeaks,
	},
	{
		title: 'Behind-the-Ear (BTE) - Shell',
		description:
			'For mild to profound hearing loss, Larger two-piece hearing aid, All components contained in a case that is worn behind the ear, A hard-moulded plastic case is worn behind the ear, and a custom-fit earmould extends into the ear, May be barely visible depending on case colour and earmould colour',
		button: 'Buy now',
		 
		user: 'Michael',
		userProfile: FaAssistiveListeningSystems,
	},
	{
		title: 'Micro Mould',
		description:
			'The mold should be cleaned regularly. The wax filter in the earpiece should be replaced when clogged or when the hearing instrument does not sound normal.',
		button: 'Buy now',
	 
		user: 'Michael',
		userProfile: FaClone,
	},
	{
		title: 'In-the-Canal (ITC) - Shell',
		description:
			'In-the-Canal-Power (ITC-P), For mild to moderately severe hearing loss, Small one piece hearing aid, All components contained in a custom-fit, hard moulded plastic shell, Fits outside the ear canal, Slightly visible in the ear',
		button: 'Buy now',
	 
		user: 'Michael',
		userProfile: FaCompactDisc,
	}
	
];